module.exports = __webpack_public_path__ + "img/dol53.b39463a8.jpeg";